import React from 'react';

import { howWeWorkData } from '../static/data';
import Intro from '../components/Intro';
import CTA from '../components/CTA';
import Reasoning from '../components/Reasoning';
import RegularBlock from '../components/RegularBlock';
import SocialBlock from '../components/SocialBlock';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO';

function HowWeWork() {
  let { intro, reasoning, regularBlock } = howWeWorkData;
  return (
    <>
      <SEO
        title="WE3 Academy | How We Work | Coding Bootcamp"
        description="WE3 Academy is where education meets a real-world professional network. We’re a career accelerator. We help our students to be hired right after they graduate and form a community of developers, designers, and entrepreneurs."
        keywords="WE3 Academy, WE3, career facilitators, career accelerator, career counselor, career help, careers, career counselling, career guidance services, career guidance and counselling, career guidance, career support, career counsell, recruitment resource, life skill coaching, interview prep,  interview preparation, job search help, job search, job, dev community, graduates, career coach, career adviser"
        link="/process"
      />
      <section id="howWeWork">
        <ScrollToTop />
        <Intro sectionId="howWeWorkIntro" intro={intro} />
        <Reasoning reasoning={reasoning} />
        <RegularBlock data={regularBlock} />
        <CTA styleType="style5" />
        <SocialBlock styleType="style1" />
      </section>
    </>
  );
}

export default HowWeWork;
